import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isMobileMenuOpen: false,
  isSearchOpen: false,
  isNotificationPanelOpen: false,
  currentTheme: 'light',
  language: 'en',
  currency: 'KES',
  notifications: [],
  toast: null,
  modal: {
    isOpen: false,
    type: null,
    props: {},
  },
  drawer: {
    isOpen: false,
    type: null,
    props: {},
  },
  breadcrumbs: [],
  pageTitle: '',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    closeMobileMenu: (state) => {
      state.isMobileMenuOpen = false;
    },
    toggleSearch: (state) => {
      state.isSearchOpen = !state.isSearchOpen;
    },
    closeSearch: (state) => {
      state.isSearchOpen = false;
    },
    toggleNotificationPanel: (state) => {
      state.isNotificationPanelOpen = !state.isNotificationPanelOpen;
    },
    closeNotificationPanel: (state) => {
      state.isNotificationPanelOpen = false;
    },
    setTheme: (state, action) => {
      state.currentTheme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
      localStorage.setItem('currency', action.payload);
    },
    showToast: (state, action) => {
      state.toast = {
        id: Date.now(),
        type: action.payload.type || 'info',
        message: action.payload.message,
        duration: action.payload.duration || 4000,
        action: action.payload.action || null,
      };
    },
    hideToast: (state) => {
      state.toast = null;
    },
    openModal: (state, action) => {
      state.modal = {
        isOpen: true,
        type: action.payload.type,
        props: action.payload.props || {},
      };
    },
    closeModal: (state) => {
      state.modal = {
        isOpen: false,
        type: null,
        props: {},
      };
    },
    openDrawer: (state, action) => {
      state.drawer = {
        isOpen: true,
        type: action.payload.type,
        props: action.payload.props || {},
      };
    },
    closeDrawer: (state) => {
      state.drawer = {
        isOpen: false,
        type: null,
        props: {},
      };
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
      document.title = action.payload ? `${action.payload} - TLC Solar` : 'TLC Solar Marketplace';
    },
    addNotification: (state, action) => {
      state.notifications.unshift({
        id: Date.now(),
        timestamp: new Date().toISOString(),
        ...action.payload,
      });
      
      // Keep only latest 50 notifications
      if (state.notifications.length > 50) {
        state.notifications = state.notifications.slice(0, 50);
      }
    },
    markNotificationAsRead: (state, action) => {
      const notification = state.notifications.find(n => n.id === action.payload);
      if (notification) {
        notification.read = true;
      }
    },
    markAllNotificationsAsRead: (state) => {
      state.notifications.forEach(n => n.read = true);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
});

export const {
  setLoading,
  toggleMobileMenu,
  closeMobileMenu,
  toggleSearch,
  closeSearch,
  toggleNotificationPanel,
  closeNotificationPanel,
  setTheme,
  setLanguage,
  setCurrency,
  showToast,
  hideToast,
  openModal,
  closeModal,
  openDrawer,
  closeDrawer,
  setBreadcrumbs,
  setPageTitle,
  addNotification,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  removeNotification,
  clearNotifications,
} = uiSlice.actions;

export default uiSlice.reducer;